import { Box, Stack, Typography } from "@mui/material";
import TitleAndContent from "./TitleAndContent";

export default function DowndloadSection({ urlDownload }) {
    return <Stack sx={{
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        marginTop: '-8rem'
    }}>
        <TitleAndContent title={"Boost your dev productivity macOS with\ncleanup of unused files and caches"} content={
            "EzClean is an application designed to help tidying up their development environment.\nSay goodbye to cluttered file systems and unnecessary caches"
        } />
        <Stack direction="row" sx={{
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            <Box variant="contained" sx={{
                background: 'linear-gradient(to right bottom, #57F1B3, #00D4F6)',
                padding: '2rem',
                borderRadius: '1rem',
                cursor: 'pointer'
            }}
                onClick={() => { window.open(urlDownload, "") }}
            >
                <Typography sx={{
                    color: '#ffffff',
                    fontSize: '3rem',
                    lineHeight: '4rem',
                    fontWeight: 'bold'
                }}>
                    Download now!
                </Typography>
            </Box>
            <Stack direction="row" sx={{
                padding: '2rem',
                border: '1px solid #000000',
                borderRadius: '1rem',
                cursor: 'pointer',
                alignItems: 'center',
                marginLeft: '3rem'
            }}
                onClick={() => {
                    window.open("https://apps.apple.com/app/ezclean-for-developers/id6581486175", '')
                }}
            >
                <Typography sx={{
                    fontSize: '3rem',
                    lineHeight: '4rem',
                    fontWeight: 'bold',
                    marginRight: '1rem'
                }}>
                    Download via App store
                </Typography>
                <img src="./app_store.png" alt="app_store" width="32px" height="32px" />
            </Stack>
        </Stack>
    </Stack>
}